var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/img/loading.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }